import { render } from "./ImagePick.vue?vue&type=template&id=643a0f14"
import script from "./ImagePick.vue?vue&type=script&lang=js"
export * from "./ImagePick.vue?vue&type=script&lang=js"

import "./ImagePick.vue?vue&type=style&index=0&id=643a0f14&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__